const selectors = {
  SHOW_TEXT_SELECTOR: '.js-button-show-text',
  CONTENT_ITEM_SELECTOR: '.text-switch__content-item',
  LOGO_ITEM_SELECTOR: '.js-logo-item',
  LOGO_ACTIVE_CLASS: 'text-switch__logo--active',
  CONTENT_ACTIVE_CLASS: 'text-switch__content--active'
}

class TextSwitch extends HTMLElement {
  constructor() {
    super()

    this.butnShowTextEls = this.querySelectorAll(selectors.SHOW_TEXT_SELECTOR)
    this.contentItemEls = this.querySelectorAll(selectors.CONTENT_ITEM_SELECTOR)
    this.logoItemEls = this.querySelectorAll(selectors.LOGO_ITEM_SELECTOR)
  }

  connectedCallback() {
    this.attachEvents()
  }

  attachEvents() {
    const swiperLogo = new Swiper ('.js-logo-carousel .swiper', {
      slidesPerView: 'auto',
      spaceBetween: 25,
      breakpoints: {
        1024: {
          spaceBetween: 30
        }
      }
    })

    if (this.butnShowTextEls.length > 0) {
      this.butnShowTextEls.forEach((item) => {
        item.addEventListener('click', () => {
          const contentItemEls = this.querySelectorAll(item.dataset.selector)

          this.contentItemEls && this.removeAllClassActive(this.contentItemEls, selectors.CONTENT_ACTIVE_CLASS)
          this.logoItemEls && this.removeAllClassActive(this.logoItemEls, selectors.LOGO_ACTIVE_CLASS)

          item.classList.add(selectors.LOGO_ACTIVE_CLASS)

          if (contentItemEls.length > 0) {
            contentItemEls.forEach((item) => {
              item.classList.add(selectors.CONTENT_ACTIVE_CLASS)
            });
          }
        })
      });
    }
  }

  removeAllClassActive(items, classRemove) {
    if (items.length > 0) {
      items.forEach((item) => {
        item.classList.remove(classRemove)
      });
    }
  }
}

if (!customElements.get('text-switch')) {
  customElements.define('text-switch', TextSwitch)
}
